import { defineComponent } from 'vue';
export default defineComponent({
  setup: function setup() {
    var contrast = function contrast(on) {
      if (on) {
        var _document$querySelect;

        (_document$querySelect = document.querySelector('body')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.add('contrast');
        sessionStorage.setItem('contrast', '1');
      } else {
        var _document$querySelect2;

        (_document$querySelect2 = document.querySelector('body')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.classList.remove('contrast');
        sessionStorage.removeItem('contrast');
      }
    };

    var fontSize = function fontSize(size) {
      if (size) {
        var _document$querySelect3;

        sessionStorage.setItem('fontSize', size);
        (_document$querySelect3 = document.querySelector('body')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.classList.add('fontSize' + size);
      } else {
        var _document$querySelect4, _document$querySelect5;

        (_document$querySelect4 = document.querySelector('body')) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.classList.remove('fontSizeM');
        (_document$querySelect5 = document.querySelector('body')) === null || _document$querySelect5 === void 0 ? void 0 : _document$querySelect5.classList.remove('fontSizeL');
        sessionStorage.removeItem('fontSize');
      }
    };

    var checkAccessibility = function checkAccessibility() {
      if (sessionStorage.getItem('contrast') !== null) {
        contrast(true);
      }

      if (sessionStorage.getItem('fontSize') !== null) {
        fontSize(sessionStorage.getItem('fontSize'));
      }
    };

    checkAccessibility();
    return {
      contrast: contrast,
      fontSize: fontSize
    };
  }
});